import styled from '@emotion/styled'

import { Image } from '@/components/Image'
import { BodyP } from '@/components/Typography'
import { sanitizeUrl } from '@/core/utils/dom/security'

interface ProductProps {
  description: string
  icon: string
  alt: string
  url: string
  width: number
  height: number
}

const ProductStyles = styled.a({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
  '& span': {
    display: 'block',
  },
})

const Product = ({ icon, description, url, alt, ...imageProps }: ProductProps) => (
  <ProductStyles as="a" href={sanitizeUrl(url)} className="productListItem">
    <BodyP tag="span" dark="medium">
      <Image source={icon} alt={alt || description} {...imageProps} />
      <span>{description}</span>
    </BodyP>
  </ProductStyles>
)

export default Product
